// relative
import { expressApiSlice } from '../apiSlice';

export const systemStatusApiSlice = expressApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSystemStatus: builder.query({
      query: () => '/system-status',
      // Poll every 5 minutes
      pollingInterval: 300000,
    }),
  }),
});

export const { useGetSystemStatusQuery } = systemStatusApiSlice;
